import { formatDate } from './formatDate';

export function getForwardSlashDate(date) {
  return formatDate(date, 'forward-slash');
}
